import Vue from "vue";
import localforage from "localforage";
import Store from "@/store";
import { querySystemConfig } from "@/api/sysDict";

Vue.prototype.$EventBus = new Vue();
Vue.prototype.$forage = localforage;

// configStatic -> global config
Vue.prototype.$configText = window.configText;
Vue.prototype.escapeHtml = function(str) {
  if (!str) return "";
  var arrEntities = {
    lt: "<",
    gt: ">",
    nbsp: " ",
    amp: "&",
    quot: '"'
  };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
    return arrEntities[t];
  });
};
// 自定义console
const PROCESS_ENY = process.env.NODE_ENV;
Vue.prototype.console = function(...params) {
  if (PROCESS_ENY == "development") {
    console.log(...params);
  }
};
// 自定义返回
Vue.prototype.$goBack = function(vm) {
  // let path = sessionStorage.getItem("path");
  // if (path) {
  //   vm.$router.push(path);
  // } else {
  vm.$router.push("/");
  // }
};

/* Vue.prototype.$systemConfig = function() {
  let vm = this;
  return new Promise(function(resolve, reject) {
    if (!window.systemConfigData) {
      let systemConfigData = {};
      vm.$http.post("/api/lottery/sysDict/querySystemConfig").then(response => {
        if (response.data.code !== 0) return;
        response.data.data.forEach(item => {
          systemConfigData[item.key] = item.value;
        });
        resolve(systemConfigData);
        window.systemConfigData = systemConfigData;
      });
    } else {
      resolve(window.systemConfigData);
    }
  });
}; */

let lastTime = 0;
Vue.prototype.$systemConfig = function() {
  const vm = this;
  const fetchData = function(resolve) {
    querySystemConfig().then(response => {
      if (response.data.code !== 0) return;
      let systemConfigData = {};
      response.data.data.forEach(item => {
        systemConfigData[item.key] = item.value;
      });
      resolve(systemConfigData);
      Store.commit("SET_SYSDICT_SYSTEMCONFIG", systemConfigData);
    });
  };
  const nowTime = +new Date();
  if (nowTime - lastTime > 2000) {
    lastTime = nowTime;
    return (window.$systemConfigPromise = new Promise(function(
      resolve,
      reject
    ) {
      fetchData(resolve);
    }));
  } else {
    return window.$systemConfigPromise;
  }
};

Vue.prototype.$tex = function() {
  const args = Array.prototype.slice.apply(arguments);
  const text = args[0];
  const options = args[1] || {};
  if (Store.getters.isInternational) {
    if (
      text === "元" ||
      text === "¥" ||
      text === "￥" ||
      text === "RMB" ||
      text === "人民币"
    ) {
      return Store.getters.sysCurrency.currencyIcon;
    }
    if (options.unit) {
      options.unit = Store.getters.sysCurrency.currencyIcon;
    }
  }
  return this.$t.apply(this, args);
};
